module.exports = __webpack_public_path__ + "static/awards-logo5-9074c4b1d826383cf2caa4de240daa1e.jpg";